import {doc} from './documentation.js';
import {publish} from 'messaging/queue.js'; 

doc(
    "rewind",
    {
        distance: "how many triggers to rewind by"
    },
    "Rewinds the parameter values to distance-many triggers ago"
);
export const rewind = (position) => {
    return (coords, speed, width, stepNumber, history) => {
        let rewinded = history[history.length - position];
        if (rewinded) {
            return rewinded;
        } else {
            return coords;
        }
    };
};

doc(
    "reset",
    {
    },
    "Resets the parameter state to the initial values"
);
export const reset = (filter=true) => {
    return (coords, speed, width, stepNumber, history, ratio, effect) => {
        if (history[0]) {
            if (filter) {
                let _coords = {};
                Object.keys(coords).forEach(
                    id => _coords[id] = history[0][id]);
                return _coords;
            }
            if (effect) {
                publish('planarReset', effect.id);
            }
            return history[0];
        } else {
            return coords;
        }
    };
};
